import { Card, CardContent, CardHeader, CardTitle } from '@/client/components/ui/card';
import { Badge } from '@/client/components/ui/badge';
import { Building, Briefcase } from 'lucide-react';
import type { ClientVendor } from '@shared/types';

interface VendorsCardProps {
  vendors: ClientVendor[];
}

export function VendorsCard({ vendors }: VendorsCardProps) {
  if (vendors.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base font-medium flex items-center gap-2">
            <Briefcase className="h-4 w-4" />
            Vendors / Contractors
          </CardTitle>
          <Badge variant="secondary">{vendors.length}</Badge>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {vendors.map((vendor) => (
            <div
              key={vendor.vendorID}
              className="flex items-center gap-2 text-sm"
            >
              <Building className="h-4 w-4 text-muted-foreground" />
              <span className="font-medium">
                {vendor.vendorName || `Vendor ${vendor.vendorID}`}
              </span>
              {vendor.vendorCode && (
                <Badge variant="outline" className="text-xs font-mono">
                  VendorID: {vendor.vendorCode}
                </Badge>
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
